import { render, staticRenderFns } from "./VideoTutorial.vue?vue&type=template&id=0a7a484b&scoped=true&"
import script from "./VideoTutorial.vue?vue&type=script&lang=js&"
export * from "./VideoTutorial.vue?vue&type=script&lang=js&"
import style0 from "./VideoTutorial.vue?vue&type=style&index=0&id=0a7a484b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7a484b",
  null
  
)

export default component.exports